import React from 'react';

import { useTranslation } from '@common/hooks/translation';
import NumericInput from '@common/components/numericInput';

export const ForgotPasswordConfirm = ({ form, errors, setForm }) => {
  const t = useTranslation();

  return (
    <div className="input-container">
      <div className='title-row'>
        <div className='title-row-text'>
          {t('Password Reset Confirmation')}
        </div>
      </div>
      <div className="title-row">
        <p className="forgot-title-row-text">
          {t('PLEASE CALL THE ADMIN FOR IN PASSWORD CHANGE APPROVAL')}
        </p>
      </div>
      <div className="main-middle-row">
        <div className="container-for-icon">
          <i className="global-icon icon-person main-middle-icon reset" />
        </div>
      </div>
      <div className="label-row">
        <p className="label-text">{t('PLAYER CPF NUMBER')}</p>
      </div>
      <div className="input-row">
        <NumericInput
          className="numeric-input"
          value={form.cpf}
          disabled={true}
        />
      </div>
      <div className="label-row">
        <p className="label-text">{t('MANAGER PASSWORD')}</p>
      </div>
      <div className="input-row">
        <NumericInput
          className="numeric-input"
          type="password"
          onChange={(val) => setForm({ ...form, adminPassword: val })}
          value={form.adminPassword}
        />
      </div>
      {
        errors.adminPassword
        && (
          <div className="error-row" style={{ display: '' }}>
            <i className="global-icon icon-toast-error error-icon-cont" />
            <p className="error-row-text">
              {t(errors.adminPassword)}
            </p>
          </div>
        )
      }
    </div>
  );
};
